globalThis.globalLanguageDebugMode = globalThis.globalLanguageDebugMode ?? false;

export function globalLanguageDebugMode(): boolean {
  return globalThis.globalLanguageDebugMode;
}

globalThis.languageServerDebugMode =
  globalThis.languageServerDebugMode ??
  ((value: boolean) => {
    globalThis.globalLanguageDebugMode = value;
    sessionStorage.setItem('language:enableDebugMode', value ? 'true' : 'false');
    globalThis.dealerConfiguration?.litApp?.updateLogoTemplate?.();
    globalThis.dealerConfiguration?.litApp?.requestUpdate?.();
    window.location.reload();
  });
